export const TWYLL_OFFLINE = 'twyll-offline'

export const SW_CACHED_ROUTES = Object.freeze({
  address: '/api/offline/address/',
  treatmentPlans: '/api/offline/client/',
  upcomingSessions: '/api/sessions/v1/sessions/upcoming/?range=week',
  user: '/api/users/v1/user/',
  allClients: '/api/clients-api/v1/clients/associated/',
  myClients: '/api/clients-api/v1/clients/',
})
